import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Box } from '@mui/material';
import { CANvisionProvider } from './context/CANvisionProvider';
import CANvisionDashboard from './components/Dashboard/CANvisionDashboard';
import { CANvisionVideoWall } from './CANvisionVideoWall';
import { CANvisionEventsPage } from './CANvisionEventsPage';
import CANvisionIncidentsPage from './CANvisionIncidentsPage';
import ErrorBoundary from 'components/errorBoundary/ErrorBoundary';

// ---------------------------------------------------------------------------
// CANvisionLayout
// ---------------------------------------------------------------------------

/**
 * Root layout component for all CANvision routes.
 *
 * Responsibilities:
 *  - Wraps the entire CANvision route tree with `<CANvisionProvider>`
 *    so all child pages share a single context (sites, cameras, socket, etc.).
 *  - Provides an `<ErrorBoundary>` so crashes in child pages are caught
 *    gracefully without bringing down the entire application.
 *  - Renders nested `<Routes>` internally because the app's `protectedRouteData`
 *    flat-map renderer does not support React Router `children` arrays natively.
 *
 * Route structure:
 *  /canvision            -> CANvisionDashboard (index)
 *  /canvision/video-wall -> CANvisionVideoWall (P3-04)
 *  /canvision/events     -> CANvisionEventsPage (MVP E-1)
 *  /canvision/incidents  -> CANvisionIncidentsPage (MVP E-2)
 *
 * Created as part of Phase 3, task P3-00 (Route Restructuring).
 */
export function CANvisionLayout() {
  return (
    <CANvisionProvider>
      <ErrorBoundary>
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '95vh' }}>
          <Box sx={{ flex: 1, p: { xs: 0, sm: 2 }, display: 'flex', flexDirection: 'column' }}>
            <Routes>
              <Route index element={<CANvisionDashboard />} />
              <Route path="video-wall" element={<CANvisionVideoWall />} />
              <Route path="events" element={<CANvisionEventsPage />} />
              <Route path="incidents" element={<CANvisionIncidentsPage />} />
            </Routes>
          </Box>
        </Box>
      </ErrorBoundary>
    </CANvisionProvider>
  );
}

export default CANvisionLayout;
